module.exports = __webpack_public_path__ + "img/cen_03.d1eaf40d.png";